const state = {
  listaEventDiscounts: [],
  eventDiscount: {
    id: null,
    descricao: "",
    evento: { id: null },
    tipo: { id: null },
    tipoRegistro: { id: null },
    percentualDesconto: null,
    valorDesconto: null,
    ativo: true,
  },
};

export default state;
